import angular from 'angular';
import { RelevantContentComponent as component } from './relevant-content.component';

export const RelevantContentComponent = angular
  .module('components.relevant-content', [])
  .component('uRelevantContent', component);
